export const DEFAULT_SCALE_FACTOR = 0.8; // See "Action.default_scale_factor"
